import {createAction} from '@reduxjs/toolkit';
import {type DrawersValueType} from '@src/constants/index.ts';
import {type ModalsValueType} from '@src/constants/modals.ts';

export const showModal = createAction<ModalsValueType>('SHOW_MODAL');
export const hideModal = createAction<ModalsValueType>('HIDE_MODAL');

export const setMode = createAction('SET_MODE');
export const showLeftDrawer = createAction<DrawersValueType | ''>(
  'DRAWER_SHOW_LEFT',
);
export const showRightDrawer = createAction<DrawersValueType | ''>(
  'DRAWER_SHOW_RIGHT',
);

export const setSaveErrors = createAction('SAVE_ERRORS');
